import CartIcon from "../../../assets/mdi_cart.png";
import "./BuyNowButton.css";

const BuyNowButton = ({
  isBuyNowDisabled,
  isAddToCartDisabled,
  handleBuy,
  handleAddToCart,
  size,
}) => {
  return (
    <div
      className={`purchase-buttons-container ${
        size === "small"
          ? "buy-now-button-container-small"
          : "buy-now-button-container-large"
      }`}
    >
      <button
        className={`buy-now-button ${
          size === "small" ? "buy-now-button-small" : "buy-now-button-large"
        }`}
        onClick={handleBuy}
        disabled={isBuyNowDisabled}
      >
        Buy now
      </button>
      <button
        className="cart-button"
        onClick={handleAddToCart}
        disabled={isAddToCartDisabled}
      >
        <img
          src={CartIcon}
          alt="Cart"
          className={`${size === "small" ? "image-small" : "image-large"}`}
        />
      </button>
    </div>
  );
};

export { BuyNowButton };
